import { getLineItemNotTreatedByLogisticianQuantity } from "@babackapp/calculations/get-line-item-not-treated-by-logistician-quantity";
import { getLineItemTreatedByMerchantQuantity } from "@babackapp/calculations/get-line-item-treated-by-merchant-quantity";
import type { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";

/**
 * BAB-2943. With re-validation allowed, a unit treated by the merchant is
 * still awaiting the logistician's inspection, and is already rendered as
 * `ready-for-logistician`. Listing it again as `treated-by-merchant` would
 * show the same physical unit twice. Only the surplus the merchant treated
 * beyond what is left to inspect belongs to that second list — so a partially
 * inspected line still accounts for all its units, across the two rows.
 */
export function getMerchantTreatedQuantityToDisplay(
  lineItem: ReturnRequestLineItemDto,
  canRevalidateAfterMerchant: boolean,
): number {
  const treatedByMerchant = getLineItemTreatedByMerchantQuantity({ lineItem });

  if (!canRevalidateAfterMerchant) {
    return treatedByMerchant;
  }

  return Math.max(
    0,
    treatedByMerchant -
      getLineItemNotTreatedByLogisticianQuantity({
        lineItem,
        allowRevalidationAfterMerchant: true,
      }),
  );
}
